import React from 'react';

const PatientTrialMatch = ({ patient }) => {
  const defaultPatient = {
    name: "James Wilson",
    age: 63,
    gender: "M",
    diagnosis: "NSCLC, Stage IIIB, PDL1 70%"
  };
  
  const patientData = patient || defaultPatient;
  
  return (
    <div className="bg-white p-4 rounded-lg shadow mb-4">
      <h3 className="text-lg font-medium mb-3">
        Patient: {patientData.name}, {patientData.age}{patientData.gender}
      </h3>
      <p className="text-gray-600 mb-2">Diagnosis: {patientData.diagnosis}</p>
    </div>
  );
};

export default PatientTrialMatch;